import { useRef, useEffect } from 'react';
import _noop from 'lodash/noop';

// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
export default function useInterval(callback: Function, delay: number) {
  const savedCallback = useRef<Function>(_noop);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}
